import { render, staticRenderFns } from "./temporary.vue?vue&type=template&id=2be58d2a&scoped=true&"
import script from "./temporary.vue?vue&type=script&lang=js&"
export * from "./temporary.vue?vue&type=script&lang=js&"
import style0 from "./temporary.vue?vue&type=style&index=0&id=2be58d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be58d2a",
  null
  
)

export default component.exports